/* eslint-disable max-len */
import { Icon, IconGraphic } from '@design-system/components/atoms/icon/entities/icon.types';

export const IconChevronFilledGraphics: { [key: string]: IconGraphic[] } = {
  [Icon.ChevronFilledDown]: [
    {
      d: 'M8.33031 11.2341L11.2159 14.6179C11.6504 15.1274 12.3523 15.1274 12.7868 14.6179L15.6724 11.2341C16.3743 10.411 15.873 9 14.8814 9H9.11021C8.11863 9 7.62841 10.411 8.33031 11.2341Z'
    }
  ],
  [Icon.ChevronFilledUp]: [
    {
      d: 'M8.33031 12.7659L11.2159 9.38214C11.6504 8.87262 12.3523 8.87262 12.7868 9.38214L15.6724 12.7659C16.3743 13.589 15.873 15 14.8814 15H9.11021C8.11863 15 7.62841 13.589 8.33031 12.7659Z'
    }
  ]
};
